var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "m-no-results" }, [
    _c("img", {
      staticClass: "m-no-results__image",
      attrs: { src: "/assets/img/no-results.png", alt: "No results" },
    }),
    _vm._v(" "),
    _c("h2", { staticClass: "u-heading-secondary" }, [_vm._v("Ah sugar...")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "Your search returned no results. Please try another search term, check the spelling, or use our menu to filter items."
      ),
    ]),
    _vm._v(" "),
    _vm.suggestions.length
      ? _c("p", [
          _vm._v("You may like our products in these other categories:"),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.suggestions.length
      ? _c(
          "p",
          { staticClass: "m-no-results__suggestions" },
          _vm._l(_vm.suggestions, function (suggestion) {
            return _c(
              "a",
              { staticClass: "c-tag", attrs: { href: suggestion.url } },
              [
                _vm._v(
                  "\n            " + _vm._s(suggestion.name) + "\n        "
                ),
              ]
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }